<template>
  <transition name="slide-right">
    <div
      v-if="isShow"
      class="dialog-sidenav-right">
      <div class="header-dialog flex-container">
        <div class="font-20 color-1 font-w-semi-bold flex-grow-1">
          {{ title }}
        </div>
        <el-icon class="color-black" @click="close">
          <close-bold />
        </el-icon>
      </div>
      <div class="content-dialog">
        <slot name="content" />
      </div>
      <div v-if="footerDialog" class="footer-dialog">
        <template v-if="useSave">
          <el-button
            type="success"
            class="mt-0 btn-full-block"
            @click="save()"
          >
            {{ $t('webhook.wb_save') }}
          </el-button>
        </template>
        <template v-if="useClose">
          <el-button
            type="success"
            class="mt-0 btn-full-block"
            @click="close()"
          >
            {{ $t('webhook.wb_close') }}
          </el-button>
        </template>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue'
import { CloseBold } from '@element-plus/icons-vue'

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: 'Title'
  },
  useSave: {
    type: Boolean,
    default: false
  },
  useClose: {
    type: Boolean,
    default: false
  },
  footerDialog: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits([
  'update:show',
  'save',
  'close'
])

const isShow = computed({
  get: () => props.show,
  set: (value) => emit('update:show', value)
})

const save = () => {
  emit('save')
}
const close = () => {
  emit('close')
}
</script>
